import { segmentsAfter } from '../../components/FrostedGate/module-path';
import { ROUTES } from '../../constants/RouteNameMapping';

export type SourcingPreviewScreenKind = 'landing' | 'list' | 'savedSearch' | 'agentResults' | 'profile';

export interface SourcingPreviewScreen {
  kind: SourcingPreviewScreenKind;
  /** The list, saved search, search or company the path names. */
  id?: string;
}

/** The Sourcing screen a frosted module imitates at this path; the lists landing page is the default. */
export function sourcingPreviewScreen(pathname: string): SourcingPreviewScreen {
  const [section, id] = segmentsAfter(pathname, ROUTES.SOURCING);

  switch (section) {
    case ROUTES.LISTS:
      return { kind: 'list', id };
    case ROUTES.SAVED_SEARCHES:
      return { kind: 'savedSearch', id };
    case ROUTES.SOURCING_RESULTS:
      return { kind: 'agentResults', id };
    case ROUTES.SOURCING_PROFILE:
      return { kind: 'profile', id };
    default:
      return { kind: 'landing' };
  }
}
